import IconMaterial from '@material-ui/core/Icon';

export const Icon = (props) => {
  return <IconMaterial {...props} />;
};
